import { Button, Form, Input, message, Modal } from 'antd';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import moment from 'moment';
import {
	appendWorkOrderNotesForBuyer,
	appendWorkOrderNotesForSupplier,
} from '../../thunks/work_orders_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';

const FORM_NAME = 'reminder-form';

const SendReminderButton: FC<any> = ({
	workOrder,
	appendWorkOrderNotes,
	currentUser,
}): React.ReactElement => {
	const [modalVisible, setModalVisible] = useState(false);
	const [sending, setSending] = useState(false);

	const _onCancel = () => setModalVisible(false);
	const _showReminderModal = () => setModalVisible(true);

	const onSubmit = useCallback(
		(values) => {
			const note = {
				text: values.note,
				noteAddedBy: nullSafeGet('email', currentUser),
				noteAddedAt: moment.utc(),
			};
			const workOrderNoteDetails = {
				id: workOrder.id,
				locationId: workOrder.locationId,
				note,
			};
			setSending(true);
			appendWorkOrderNotes(workOrderNoteDetails)
				.then(() => {
					message.success(`Reminder sent successfully!`);
					_onCancel();
				})
				.catch((err) => message.error(err))
				.finally(() => setSending(false));
		},
		[appendWorkOrderNotes, currentUser, workOrder.id, workOrder.locationId]
	);

	const defaultMessage = useMemo(
		() =>
			`We are ready to publish the invoice for WO# ${workOrder.id}, please review the work completed and approve`,
		[workOrder.id]
	);

	return (
		<>
			<Button type="primary" onClick={_showReminderModal} className="ml-2">
				Send Reminder
			</Button>
			{modalVisible ? (
				<Modal
					visible={true}
					width={600}
					title="Send Reminder"
					onCancel={_onCancel}
					onOk={onSubmit}
					closable
					footer={[
						<Button onClick={_onCancel} size="large">
							Cancel
						</Button>,
						<Button
							type="primary"
							size="large"
							style={{ marginLeft: '16px' }}
							key="submit"
							htmlType="submit"
							form={FORM_NAME}
							loading={sending}
						>
							Send
						</Button>,
					]}
				>
					<Form
						id={FORM_NAME}
						layout="vertical"
						initialValues={{ note: defaultMessage }}
						onFinish={onSubmit}
					>
						<Form.Item label="Notes" name="note">
							<Input.TextArea />
						</Form.Item>
					</Form>
				</Modal>
			) : null}
		</>
	);
};
const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	appendWorkOrderNotes: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? appendWorkOrderNotesForSupplier(entity)
				: appendWorkOrderNotesForBuyer(entity)
		),
});

const ComponentWithoutUserType = connect(mapStateToProps, mapDispatchToProps)(SendReminderButton);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
